
































































































































































































































/*
  getTeacherDetailInfo 查看教师详情
  signUp 专家报名
*/
import { Vue, Component } from "vue-property-decorator";
import {
  getTeacherDetailInfo,
  signUp,
  getSource,
  getTchOtherInfo,
  save
} from "../../../api/teacherRole";
import { Form as ElForm } from "element-ui";
import { getToken } from "../../../utils/auth";
//引入vuex中的user模块
import { UserModule } from "../../../store/modules/user";
import {
  validateMax32,
  validateAge,
  validateTeacherAge,
  blurTeacherAge,
  ruleNormal,
  rulePattern,
  validatePhone,
  validateOpeningBank,
  validateBankCard,
  validateIntroduction,
  validateAddress,
  validateEmail
} from '@/utils/regxCustom'
//自定义对象接口
interface CustomForm {
  [propName: string]: any;
}

@Component({
  name: "expertsSignUp"
})
export default class extends Vue {
  private showExcellentTeacher = false //隐藏优秀教师
  private uploadUrl: string =
      window.config.baseUrl4WebTeacher + "/teacher/signuUp/upLoadHeadImage"; //上传地址
  private infoForm: CustomForm = {
    sourceId: "",
    subjectId: ""
  }; //教师信息
  private imageUrl: string = ""; //头像地址
  private teacherID : string = "" // 保存最初身份证信息
  private subjects: object[] = []; //“来源”数组
  private upload = {
    header: {
      Authorization: getToken(),
      access_token: getToken()
    },
    fileList: []
  };

  // 项目 下拉列表
  private projectList: Array<object> = [];
  private typeList: Array<object> = [];
  private projId: string = ""; // 全局项目id
  private fullscreenLoadind: boolean = false; //spin toggle
  private uploadCard: object = {
    headers: {
      Authorization: getToken(),
      access_token: getToken()
    },
    url: `${window.config.baseUrl4WebTeacher}/teacher/signuUp/upLoadGreedCode`,
    accept: ".jpg",
    fileList: []
  }
  private greenCodefile = ''   //绿码地址
  
  // 审核状态
  private auditStatus1: number | null = null;
  private auditStatus2: number | null = null;
  private auditStatus3: number | null = null;
  
  created() {
    //获取教师信息
    this.getInfo();
  }

  // 验证
  private infoFormRules: object = {
    teacherBirthday: [ruleNormal("请选择出生日期")],
    teacherProfessionalId: [ruleNormal("请填写职称")],
    teacherTeachingAge: [
      ruleNormal("请填写教龄"),
      { validator: validateTeacherAge },
      { validator: blurTeacherAge, trigger: "blur" }
    ],
    teacherGradeId: [ruleNormal("请填写任课年级")],
    teacherPhone: [
      ruleNormal("请输入手机号码"),
      // { validator: validatePhone }
    ],
    teacherOpeningBank: [
      ruleNormal("请输入开户行")
    ],
    sourceId: [ruleNormal("请选择报名类型")],
    projectId: [ruleNormal("请选择项目")],
    subjectId: [ruleNormal("请选择科目")],
    teacherAge: [ruleNormal("请填写年龄"), { validator: validateAge }],
    teacherGenderId: [ruleNormal("请填写性别")],
    teacherEmail: [ { validator: validateMax32 }],
    teacherAddress:[{ validator: validateAddress }],
    otherinfoIntroduction:[ruleNormal("请输入个人简历"), { validator: validateIntroduction }],
    otherinfoHaveRelatives:[ruleNormal("请选择是否近亲或利害关系人高考")],
    teacherCreditCard:[ruleNormal("请输入银行卡号")], //这里只限制长度即可
    teacherCarNumber: [ { validator: validateMax32 }],
  };

  //获取教师信息
  private async getInfo() {
    try {
      let res = await getTeacherDetailInfo();
      this.infoForm = res.data.detailVo;
      this.teacherID = this.infoForm.teacherCard;
      this.infoForm.professionals = res.data.professionals;
      this.infoForm.subjects = res.data.subjects;
      this.infoForm.sources=res.data.sources;
      this.infoForm.grades = res.data.grades;
      this.infoForm.genders = res.data.genders;
      this.projectList = res.data.projects;
      this.imageUrl = res.data.base64String?'data:image/jpeg;base64,'+res.data.base64String: "";
      // this.imageUrl = this.infoForm[`teacherPhotoPath`]
      //     ? window.config.baseUrl4Shool + this.infoForm[`teacherPhotoPath`]
      //     : "";
    } catch (error) {
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  private async getTypeList(val) {
    let projRes = await getSource(val);
    if(projRes!=null && projRes.data.sourceId!=null){
       this.infoForm.sourceId = projRes.data.sourceId;
       this.infoForm.subjectId = projRes.data.subjectId;
    }else{
      this.$set(this.infoForm,'sourceId','');
      this.$set(this.infoForm,'subjectId','');
    }
    if (projRes!=null && projRes.data.subject !=null) {
      this.subjects = projRes.data.subject;
    }else{
      this.subjects = [];
    }

    // 获取审核状态
    this.auditStatus1 = (projRes.data && projRes.data.auditStatus1 !== undefined) ? projRes.data.auditStatus1 : null;
    this.auditStatus2 = (projRes.data && projRes.data.auditStatus2 !== undefined) ? projRes.data.auditStatus2 : null;
    this.auditStatus3 = (projRes.data && projRes.data.auditStatus3 !== undefined) ? projRes.data.auditStatus3 : null;

    // 添加调试日志
    console.log('审核状态:', {
      auditStatus1: this.auditStatus1,
      auditStatus2: this.auditStatus2,
      auditStatus3: this.auditStatus3,
      hasAuditPassed: this.hasAuditPassed
    });

    this.$forceUpdate();
  }
  
  // 判断是否已有审核通过（任一审核通过则不允许修改）
  get hasAuditPassed() {
    return this.auditStatus1 === 1 || this.auditStatus2 === 1 || this.auditStatus3 === 1;
  }
  
  private async getOtherInfo(val) {
    this.$forceUpdate()  //强制刷新
    if (!val) return false;
    // let infoRes = await getTchOtherInfo(this.projId, val);
    // this.infoForm.subjectName = infoRes.data.subjectName;
    // // this.infoForm.otherinfoIsExcellentTeacher = infoRes.data.subjectName
    // this.infoForm.teacherDistrictId = infoRes.data.teacherDistrictId;
    // // this.infoForm.teacherOpeningBank = infoRes.data.teacherOpeningBank;
    // // this.infoForm.teacherCreditCard = infoRes.data.teacherCreditCard;
    // this.infoForm.otherinfoIsExcellentTeacherValue = infoRes.data.otherinfoIsExcellentTeacherValue;
    // this.infoForm.otherinfoIntroduction = infoRes.data.otherinfoIntroduction;
    this.infoForm.otherinfoSourceId = val;
  }

  // 上传头像
  private handleAvatarSuccess(res: any, file: any) {
    // this.infoForm.teacherPhotoPath = URL.createObjectURL(file.raw);
    if (res.code != "20000000") {
      this.$message.error(res.mesg);
    }
    console.log(res.data);
    this.infoForm.teacherPhotoPath = res.data.path;
    this.imageUrl = 'data:image/jpeg;base64,'+res.data.base64String;
    // this.imageUrl = window.config.baseUrl4Shool + res.data;
    // this.$set(this.infoForm,`teacherPhotoPath`,res.data)
    this.$forceUpdate();
    // (this.$refs.upload as any).clearFiles();
  }

  private beforeAvatarUpload(file: any) {
    // const isJPG = file.type === "image/jpeg || jpg";
    const isJPG = file.type === "image/jpeg";
    const isJPG2 = file.type === "image/jpg";
    // const isJPG = file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG && !isJPG2) {
      this.$message.error("上传头像图片只能是 JPG 格式!");
    }
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 2MB!");
    }
    return isJPG && isLt2M;
  }

  // 保存
  private async submitTeacherInfo() {
    // 检查审核状态
    if (this.hasAuditPassed) {
      this.$message.error("该报名信息已有审核通过，不允许修改");
      return;
    }
    
    (this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.$set(this.infoForm, 'file', this.greenCodefile)


          this.fullscreenLoadind = true;
          if(this.teacherID === this.infoForm.teacherCard){
            await save(this.infoForm);
            this.fullscreenLoadind = false;
            this.$message.success("保存成功");
          }else{
            this.$confirm(`您的身份证号发生修改为：${this.infoForm.teacherCard}，修改后将退出页面，是否继续?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async () => {
              await save(this.infoForm);
              this.fullscreenLoadind = false;
              this.$message.warning('保存成功')
              setTimeout(async ()=>{
                //调登录的接口，获取token
                await UserModule.LogOut()
                this.$router.push("/")
              },1000)
            }).catch(()=>{
              this.fullscreenLoadind = false;
              return
            })
          }

        } catch (error) {
          this.fullscreenLoadind = false;
          // this.$message.error(error || "保存失败");
          this[`$message`]({
            type: "error",
            message: error!.mesg ? error!.mesg : error
          });
        }
      }
    });
  }
  private filePicFilter(val) {
    return val.substring(val.lastIndexOf(".") + 1);
  }
  //上传绿码文件
  private beforeUpload(file: any) {
    let type = this.filePicFilter(file.name);
    const typeName = type === "jpg";
    if (!typeName) {
      this.$message.error("只能上传jpg格式的文件!");
      return false;
    }
    let promise = new Promise(resolve => {
      this.$nextTick(function() {
        resolve(true);
      });
    });
    return promise; //通过返回一个promis对象解决
  }
  ////上传绿码文件成功后
  private uploadSuccess(response, file, fileList) {
    this.greenCodefile = response.data;
    this.clearFileList();
    this.$message.success("上传成功！");
  }
  //上传绿码文件失败
  private uploadFail(response, file, fileList) {
    this.clearFileList();
    this.$message.error("上传失败！");
  }
  //上传绿码文件 清空缓存
  private clearFileList() {
    this.uploadCard['fileList'] = [];
    let dom:any = this.$refs["uploadCardRef"];
    dom.clearFiles();
  }
}
